module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-dialogs"
    }
  }, [_c('ModalLogin'), _vm._v(" "), _c('ModalPlaySolo'), _vm._v(" "), _c('ModalPlayMultiplayers'), _vm._v(" "), _c('ModalMultiplayers'), _vm._v(" "), _c('ModalWords'), _vm._v(" "), _c('ModalRules')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee38b8e2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals.vue
// module id = 2k7r
// module chunks = 1